import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Input, Divider, Button } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { DeleteOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2';
import { sendData } from '../../httpRequests';
import { getPharmacyId } from '../../components/Shared';

export default function DriverDetails() {
	const navigate = useNavigate();
	const { id } = useParams();
	const [driver, setDriver] = useState({});
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (id !== null) {
			loadDriver(id);
		}
	}, []);

	const loadDriver = (id) => {
		const pharmacyId = getPharmacyId();
		if (!pharmacyId) {
			navigate('/login');
			return false;
		}

		const url = '/user/getDriverById';
		const data = {
			driver_id: id,
			pharmacy_id: pharmacyId
		};
		sendData(url, data).then((response) => {
			if (Object.keys(response).length > 0) {
				const driver = response['driver'];
				setDriver(driver);
			}
		});
	};

	const updateDriverProfile = (values) => {
		setIsLoading(true);
		const url = '/user/updateDriverUser';
		const data = {
			email: values.email,
			phone: values.phone,
			address_1: values.address,
			first_name: values.fullName,
			zip_code: values.zip,
			city: values.city,
			driver_id: driver.id
		};
		sendData(url, data).then((response) => {
			setIsLoading(false);
			if (Object.keys(response).length > 0) {
				Swal.fire({
					text: response['message'],
					icon: 'success',
					confirmButtonColor: '#128780'
				});
			}
		});
	};

	const updatePassword = (values) => {
		const url = '/user/updateDriverUser';
		const data = {
			password: values.password,
			driver_id: driver.id
		};
		sendData(url, data).then((response) => {
			if (Object.keys(response).length > 0) {
				Swal.fire({
					text: 'Password has been reset',
					icon: 'success',
					confirmButtonColor: '#128780'
				});
			}
		});
	};

	const deleteDriver = () => {
		Swal.fire({
			text: 'Are you sure you want to delete this driver?',
			icon: 'question',
			showCancelButton: true,
			cancelButtonText: 'No',
			confirmButtonText: 'Yes',
			confirmButtonColor: '#128780'
		}).then((result) => {
			if (result.isConfirmed) {
				const url = '/user/deleteDriver';
				const data = {
					driver_id: driver.id
				};
				sendData(url, data).then(() => {
					navigate('/drivers');
				});
			}
		});
	};

	return (
		<div>
			{Object.keys(driver).length > 0 && (
				<div>
					<Form layout='vertical' onFinish={updateDriverProfile}>
						<div>
							<div style={{ display: 'flex', justifyContent: 'space-between' }}>
								<h2 style={{ marginBottom: 30 }}>Contact information</h2>
								<Button
									onClick={deleteDriver}
									type='primary'
									danger={true}
									style={{ borderRadius: 10, width: '15%' }}
									size='large'
								>
									<DeleteOutlined />
									Delete driver
								</Button>
							</div>
							<Row gutter={24}>
								<Col span={12}>
									<Form.Item
										initialValue={driver.email}
										label='Email'
										name='email'
										rules={[
											{
												required: true
											}
										]}
									>
										<Input size='large' type='email' autoCapitalize='false' />
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item
										initialValue={driver.first_name}
										label='Full Name'
										name='fullName'
										rules={[
											{
												required: true
											}
										]}
									>
										<Input size='large' type='text' />
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col span={12}>
									<Form.Item initialValue={driver.phone} label='Phone' name='phone'>
										<Input size='large' type='phone' />
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item initialValue={driver.address_1} label='Address' name='address'>
										<Input size='large' type='address' />
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col span={12}>
									<Form.Item
										initialValue={driver.zip_code}
										label='Zip Code'
										name='zip'
										rules={[
											{
												required: true
											}
										]}
									>
										<Input size='large' type='text' />
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item initialValue={driver.city} label='City' name='city'>
										<Input size='large' type='text' />
									</Form.Item>
								</Col>
							</Row>
						</div>
						<Row gutter={24} style={{ marginTop: 30 }}>
							<Col span={24}>
								<Form.Item>
									<Button
										type='primary'
										htmlType='submit'
										loading={isLoading}
										disabled={isLoading}
										style={{ borderRadius: 10, width: '100%', backgroundColor: '#128780' }}
										size='large'
									>
										Save changes
									</Button>
								</Form.Item>
							</Col>
						</Row>
					</Form>
					<Divider />
					<Form layout='vertical' onFinish={updatePassword}>
						<div>
							<h2 style={{ marginBottom: 30 }}>Security information</h2>
							<Row gutter={24}>
								<Col span={4}>
									<Form.Item
										label='Password'
										name='password'
										rules={[
											{
												required: true
											}
										]}
									>
										<Input size='large' type="password" />
									</Form.Item>
								</Col>
								<Col span={4}>
									<Form.Item label={' '}>
										<Button
											type='primary'
											htmlType='submit'
											style={{ borderRadius: 10, width: '100%', backgroundColor: '#128780' }}
											size='large'
										>
											Reset password
										</Button>
									</Form.Item>
								</Col>
							</Row>
						</div>
					</Form>
				</div>
			)}
		</div>
	);
}
